import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { useMobileAppName } from '../../hooks/use-mobile-app-name'

import { getAuthConfig, getLayoutBackgroundSettings } from './utils'
import AuthCarousel from './AuthCarousel'

const AuthLayout = ({ children, hideLogo = false }) => {
  const { t } = useTranslation(['auth'])
  const authConfig = getAuthConfig(window.location.hostname)
  const appName = useMobileAppName()

  return (
    <React.Fragment>
      <div className="auth">
        <div className="auth__content-wrapper">
          {hideLogo ? null : (
            <img className="auth__logo" src={authConfig.logo} alt={authConfig.appName} />
          )}
          {children}
          <footer>
            <span>{t('auth:layout.copyright', { year: new Date().getFullYear() })}</span>
            <div className="divider" />
            <a href="https://www.elevatedliving.com/privacy-policy">
              {t('auth:layout.privacyPolicy')}
            </a>
            <div className="divider" />
            <a href="https://www.elevatedliving.com/terms-of-service">
              {t('auth:layout.termsOfService')}
            </a>
          </footer>
        </div>
        <div
          className="auth__photo-wrapper"
          style={{
            backgroundImage: `url(${authConfig.photo})`,
            ...getLayoutBackgroundSettings(authConfig.isDefault),
          }}
        >
          {!authConfig.isDefault && !authConfig.hideAppLinks && (
            <div className="auth__app-stores">
              <span>{t('auth:layout.downloadOurApp', { appName })}</span>
              <div className="auth__badges-wrapper">
                <a
                  className="auth__badge"
                  target="_blank"
                  rel="noreferrer"
                  href={authConfig.playStore}
                >
                  <img src="/images/get-google-play-app.svg" alt={t('auth:layout.googlePlayAlt')} />
                </a>
                <a
                  className="auth__badge"
                  target="_blank"
                  rel="noreferrer"
                  href={authConfig.appStore}
                >
                  <img src="/images/get-appstore-app.svg" alt={t('auth:layout.appStoreAlt')} />
                </a>
              </div>
            </div>
          )}
        </div>
      </div>
      <AuthCarousel />
    </React.Fragment>
  )
}

AuthLayout.propTypes = {
  hideLogo: PropTypes.bool,
  children: PropTypes.object,
}

export default AuthLayout
